module.exports = __webpack_public_path__ + "static/media/popup-bg.b0216767.png";